import { useParams, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_PAGE_NUMBER, SEARCH_PARAM_KEY_SORT, SEARCH_PARAM_KEY_TYPE } from '../constants/searchParamKeys';
import { FACET_KEY_TAGS } from '../constants/facetKeys';
import { MEDIA_BREAKPOINTS } from '../../constants/MEDIA_BREAKPOINTS';
import { queryLetter } from '../configs';
export const useNumberOfActiveFilters = () => {
    const { medium } = useParams();
    const [searchParams] = useSearchParams();
    let number = 0;
    if (medium !== undefined) {
        number++;
    }
    for (const key of searchParams.keys()) {
        if (key !== queryLetter &&
            key !== SEARCH_PARAM_KEY_PAGE_NUMBER &&
            key !== SEARCH_PARAM_KEY_SORT &&
            key !== FACET_KEY_TAGS &&
            (MEDIA_BREAKPOINTS.MD_UP.matches || key !== SEARCH_PARAM_KEY_TYPE)) {
            const value = searchParams.get(key);
            if (value !== null) {
                number += value.split(',').length;
            }
        }
    }
    return [number];
};
